module.exports = __webpack_public_path__ + "static/img/2.cb46c40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/sp/2.png
// module id = GxKg
// module chunks = 0